import AppLayout from "@components/layout/AppLayout"
import ChartAccordion from "@components/dataDisplay/chartAccordion/ChartAccordion"
import { getBoerseApiUrl } from "@utils/apiBase"

async function getServerSideProps({ query }: any) {
  const endpoint = getBoerseApiUrl()

  // Always use CUG (real-time) quotes — special-work embeds are only rendered inside
  // premium subscriber pages, so all viewers are entitled to real-time data.
  const quotesRes = await fetch(`${endpoint}/marketdata/quotes/${query.ids}?closedUsergroup=true`)
  const quotesData = await quotesRes.json()

  return { props: { quotesData } }
}

const ChartPage = ({ quotesData }: any) => {
  return (
    <AppLayout title="Chart" robots="noindex,nofollow">
      <ChartAccordion quotesData={quotesData} />
    </AppLayout>
  )
}

export { getServerSideProps }
export default ChartPage
